import apiClient from './client'
import { Sessao } from '../types/api'
import { ensureArray } from '../utils/array'

export const sessoesApi = {
  listByUsuario: async (usuarioId: number, valido?: boolean): Promise<Sessao[]> => {
    const params: any = {}
    if (valido !== undefined) {
      params.valido = valido
    }
    const response = await apiClient.get<Sessao[]>(
      `/sessoes/usuarios/${usuarioId}`,
      { params }
    )
    return ensureArray<Sessao>(response.data)
  },

  revogar: async (sessaoId: number): Promise<void> => {
    await apiClient.delete(`/sessoes/${sessaoId}`)
  },

  revogarTodas: async (usuarioId: number): Promise<{ message: string; sessoes_revogadas: number }> => {
    const response = await apiClient.post<{ message: string; sessoes_revogadas: number }>(
      `/sessoes/usuarios/${usuarioId}/revogar_todas`
    )
    return response.data
  },
}

